import ManualCrixto from "../../components/crixto";

const ManualCrixtoPage = () => {

    return (
        <ManualCrixto />
    );
};

export default ManualCrixtoPage;